// Form/API error vocabulary — consumed by lib/errorMessages.ts.
export const validation = {
  required: "This field is required",
  invalidNumber: "Please enter a valid number",
  min: "Must be {{n}} or more",
  max: "Must be {{n}} or less",
  maxLength: "Maximum {{n}} characters",
  minLength: "Minimum {{n}} characters",
  invalidOption: "Please select a valid option",
  invalidUrl: "Please enter a valid URL",
  invalidEmail: "Please enter a valid email",
  invalidValue: "Invalid value",
  coordinatesFormat:
    'Enter two numbers with a decimal point separated by a comma, e.g. "-8.79203, 115.22704"',
  coordinatesRange: "Latitude must be between -90 and 90 and longitude between -180 and 180",
  fixHighlighted: "Could not save — please fix these fields:",
  checkForm: "Please check the form — some data is not valid.",
  network: "Cannot connect to server. Check your internet connection.",
  sessionExpired: "Your session has expired. Please log in again.",
  forbidden: "You don't have permission for this action.",
  notFound: "This item was not found. It may have been deleted.",
  server: "Something went wrong on our end. Please try again later.",
  unexpected: "An unexpected error occurred.",
};
